import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedDriverRouteProps {
    children?: React.ReactNode;
}

const ProtectedDriverRoute: React.FC<ProtectedDriverRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading, user } = useAuth();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" replace />;
    }

    // Protocol A: Role Isolation
    // Allow 'rider' OR 'admin' (for debugging/supervision)
    const allowedRoles = ['rider', 'admin'];

    if (!allowedRoles.includes(user.role)) {
        // If logged in as Manager/Expeditor/etc, redirect to Main Dashboard
        // Basically, if they aren't a rider, get them out of the Driver App
        return <Navigate to="/" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default ProtectedDriverRoute;
